var map = {
	"./BSCF_logo": "./app/javascript/images/BSCF_logo.png",
	"./BSCF_logo.png": "./app/javascript/images/BSCF_logo.png",
	"./CFP_logo": "./app/javascript/images/CFP_logo.png",
	"./CFP_logo.png": "./app/javascript/images/CFP_logo.png",
	"./CWDA_logo": "./app/javascript/images/CWDA_logo.png",
	"./CWDA_logo.jpg": "./app/javascript/images/CWDA_logo.jpg",
	"./CWDA_logo.png": "./app/javascript/images/CWDA_logo.png",
	"./Contrad_N_Hilton_Foundation": "./app/javascript/images/Contrad_N_Hilton_Foundation.png",
	"./Contrad_N_Hilton_Foundation.png": "./app/javascript/images/Contrad_N_Hilton_Foundation.png",
	"./Cowell_logo": "./app/javascript/images/Cowell_logo.png",
	"./Cowell_logo.png": "./app/javascript/images/Cowell_logo.png",
	"./Golden_Door_Logo": "./app/javascript/images/Golden_Door_Logo.png",
	"./Golden_Door_Logo.png": "./app/javascript/images/Golden_Door_Logo.png",
	"./Haas-Logo": "./app/javascript/images/Haas-Logo.png",
	"./Haas-Logo.png": "./app/javascript/images/Haas-Logo.png",
	"./OCAP_Logo": "./app/javascript/images/OCAP_Logo.png",
	"./OCAP_Logo.png": "./app/javascript/images/OCAP_Logo.png",
	"./PlaybookDiagram": "./app/javascript/images/PlaybookDiagram.png",
	"./PlaybookDiagram.png": "./app/javascript/images/PlaybookDiagram.png",
	"./PreventionPlanningTeams": "./app/javascript/images/PreventionPlanningTeams.png",
	"./PreventionPlanningTeams.png": "./app/javascript/images/PreventionPlanningTeams.png",
	"./SS_logo": "./app/javascript/images/SS_logo.png",
	"./SS_logo.png": "./app/javascript/images/SS_logo.png",
	"./ZFF_logo": "./app/javascript/images/ZFF_logo.png",
	"./ZFF_logo.png": "./app/javascript/images/ZFF_logo.png",
	"./ability-to-pay-rent-2020": "./app/javascript/images/ability-to-pay-rent-2020.png",
	"./ability-to-pay-rent-2020.png": "./app/javascript/images/ability-to-pay-rent-2020.png",
	"./abuse-per-adult": "./app/javascript/images/abuse-per-adult.png",
	"./abuse-per-adult.png": "./app/javascript/images/abuse-per-adult.png",
	"./abuse-survivors": "./app/javascript/images/abuse-survivors.png",
	"./abuse-survivors.png": "./app/javascript/images/abuse-survivors.png",
	"./abuse-victimization": "./app/javascript/images/abuse-victimization.png",
	"./abuse-victimization.png": "./app/javascript/images/abuse-victimization.png",
	"./back": "./app/javascript/images/back.png",
	"./back.png": "./app/javascript/images/back.png",
	"./bay-area-poverty-estimates": "./app/javascript/images/bay-area-poverty-estimates.png",
	"./bay-area-poverty-estimates.png": "./app/javascript/images/bay-area-poverty-estimates.png",
	"./blue-boy": "./app/javascript/images/blue-boy.jpg",
	"./blue-boy.jpg": "./app/javascript/images/blue-boy.jpg",
	"./blue-dad-and-kid": "./app/javascript/images/blue-dad-and-kid.png",
	"./blue-dad-and-kid.png": "./app/javascript/images/blue-dad-and-kid.png",
	"./blue-girl": "./app/javascript/images/blue-girl.jpg",
	"./blue-girl.jpg": "./app/javascript/images/blue-girl.jpg",
	"./boy-map": "./app/javascript/images/boy-map.jpg",
	"./boy-map.jpg": "./app/javascript/images/boy-map.jpg",
	"./ca-rental-homes": "./app/javascript/images/ca-rental-homes.png",
	"./ca-rental-homes.png": "./app/javascript/images/ca-rental-homes.png",
	"./cali-unemployment-rate-graph": "./app/javascript/images/cali-unemployment-rate-graph.png",
	"./cali-unemployment-rate-graph.png": "./app/javascript/images/cali-unemployment-rate-graph.png",
	"./california-unemployment-rate": "./app/javascript/images/california-unemployment-rate.png",
	"./california-unemployment-rate.png": "./app/javascript/images/california-unemployment-rate.png",
	"./care": "./app/javascript/images/care.svg",
	"./care.svg": "./app/javascript/images/care.svg",
	"./child-abuse-victimization-graph": "./app/javascript/images/child-abuse-victimization-graph.png",
	"./child-abuse-victimization-graph-2023": "./app/javascript/images/child-abuse-victimization-graph-2023.svg",
	"./child-abuse-victimization-graph-2023.svg": "./app/javascript/images/child-abuse-victimization-graph-2023.svg",
	"./child-abuse-victimization-graph.png": "./app/javascript/images/child-abuse-victimization-graph.png",
	"./costOfAbuse-graphic-lvl1": "./app/javascript/images/costOfAbuse-graphic-lvl1.svg",
	"./costOfAbuse-graphic-lvl1.svg": "./app/javascript/images/costOfAbuse-graphic-lvl1.svg",
	"./costOfAbuse-graphic-lvl2": "./app/javascript/images/costOfAbuse-graphic-lvl2.svg",
	"./costOfAbuse-graphic-lvl2.svg": "./app/javascript/images/costOfAbuse-graphic-lvl2.svg",
	"./costOfAbuse-graphic-lvl3": "./app/javascript/images/costOfAbuse-graphic-lvl3.svg",
	"./costOfAbuse-graphic-lvl3.svg": "./app/javascript/images/costOfAbuse-graphic-lvl3.svg",
	"./crayons": "./app/javascript/images/crayons.jpg",
	"./crayons.jpg": "./app/javascript/images/crayons.jpg",
	"./crime-by-county": "./app/javascript/images/crime-by-county.png",
	"./crime-by-county.png": "./app/javascript/images/crime-by-county.png",
	"./crime-trends-california-2023": "./app/javascript/images/crime-trends-california-2023.png",
	"./crime-trends-california-2023.png": "./app/javascript/images/crime-trends-california-2023.png",
	"./crime-trends-counties-2023": "./app/javascript/images/crime-trends-counties-2023.png",
	"./crime-trends-counties-2023.png": "./app/javascript/images/crime-trends-counties-2023.png",
	"./doctor": "./app/javascript/images/doctor.svg",
	"./doctor.svg": "./app/javascript/images/doctor.svg",
	"./facebook": "./app/javascript/images/facebook.svg",
	"./facebook.svg": "./app/javascript/images/facebook.svg",
	"./family-homelessness-graph-2023": "./app/javascript/images/family-homelessness-graph-2023.svg",
	"./family-homelessness-graph-2023.svg": "./app/javascript/images/family-homelessness-graph-2023.svg",
	"./federal-child-tax-credit-for-single-parent-two-children": "./app/javascript/images/federal-child-tax-credit-for-single-parent-two-children.png",
	"./federal-child-tax-credit-for-single-parent-two-children.png": "./app/javascript/images/federal-child-tax-credit-for-single-parent-two-children.png",
	"./federalchildtaxcredit": "./app/javascript/images/federalchildtaxcredit.png",
	"./federalchildtaxcredit.png": "./app/javascript/images/federalchildtaxcredit.png",
	"./hand_logo": "./app/javascript/images/hand_logo.png",
	"./hand_logo.png": "./app/javascript/images/hand_logo.png",
	"./hero": "./app/javascript/images/hero.jpg",
	"./hero.jpg": "./app/javascript/images/hero.jpg",
	"./homelessness-graph": "./app/javascript/images/homelessness-graph.png",
	"./homelessness-graph-2023": "./app/javascript/images/homelessness-graph-2023.svg",
	"./homelessness-graph-2023.svg": "./app/javascript/images/homelessness-graph-2023.svg",
	"./homelessness-graph.png": "./app/javascript/images/homelessness-graph.png",
	"./instagram": "./app/javascript/images/instagram.svg",
	"./instagram.svg": "./app/javascript/images/instagram.svg",
	"./justice": "./app/javascript/images/justice.svg",
	"./justice.svg": "./app/javascript/images/justice.svg",
	"./linkedin": "./app/javascript/images/linkedin.svg",
	"./linkedin.svg": "./app/javascript/images/linkedin.svg",
	"./mandated-reporting-data": "./app/javascript/images/mandated-reporting-data.png",
	"./mandated-reporting-data.png": "./app/javascript/images/mandated-reporting-data.png",
	"./many-california-renters-remain-financially-stressed-figure-1": "./app/javascript/images/many-california-renters-remain-financially-stressed-figure-1.png",
	"./many-california-renters-remain-financially-stressed-figure-1.png": "./app/javascript/images/many-california-renters-remain-financially-stressed-figure-1.png",
	"./many-california-renters-remain-financially-stressed-figure-2": "./app/javascript/images/many-california-renters-remain-financially-stressed-figure-2.png",
	"./many-california-renters-remain-financially-stressed-figure-2.png": "./app/javascript/images/many-california-renters-remain-financially-stressed-figure-2.png",
	"./median-house-costs": "./app/javascript/images/median-house-costs.png",
	"./median-house-costs.png": "./app/javascript/images/median-house-costs.png",
	"./meetAnna-adolescent": "./app/javascript/images/meetAnna-adolescent.svg",
	"./meetAnna-adolescent.svg": "./app/javascript/images/meetAnna-adolescent.svg",
	"./meetAnna-adult": "./app/javascript/images/meetAnna-adult.svg",
	"./meetAnna-adult.svg": "./app/javascript/images/meetAnna-adult.svg",
	"./meetAnna-child": "./app/javascript/images/meetAnna-child.svg",
	"./meetAnna-child.svg": "./app/javascript/images/meetAnna-child.svg",
	"./migration": "./app/javascript/images/migration.png",
	"./migration.png": "./app/javascript/images/migration.png",
	"./next": "./app/javascript/images/next.png",
	"./next.png": "./app/javascript/images/next.png",
	"./open-menu": "./app/javascript/images/open-menu.svg",
	"./open-menu.svg": "./app/javascript/images/open-menu.svg",
	"./opiod-deaths-2020": "./app/javascript/images/opiod-deaths-2020.png",
	"./opiod-deaths-2020.png": "./app/javascript/images/opiod-deaths-2020.png",
	"./opioid-hospitalizations": "./app/javascript/images/opioid-hospitalizations.png",
	"./opioid-hospitalizations-2023": "./app/javascript/images/opioid-hospitalizations-2023.svg",
	"./opioid-hospitalizations-2023.svg": "./app/javascript/images/opioid-hospitalizations-2023.svg",
	"./opioid-hospitalizations.png": "./app/javascript/images/opioid-hospitalizations.png",
	"./pandemic-era-policies-graph": "./app/javascript/images/pandemic-era-policies-graph.svg",
	"./pandemic-era-policies-graph.svg": "./app/javascript/images/pandemic-era-policies-graph.svg",
	"./payment": "./app/javascript/images/payment.svg",
	"./payment.svg": "./app/javascript/images/payment.svg",
	"./people-in-families-homelessness": "./app/javascript/images/people-in-families-homelessness.png",
	"./people-in-families-homelessness.png": "./app/javascript/images/people-in-families-homelessness.png",
	"./percentage-of-unsheltered-families": "./app/javascript/images/percentage-of-unsheltered-families.png",
	"./percentage-of-unsheltered-families.png": "./app/javascript/images/percentage-of-unsheltered-families.png",
	"./playbook-cover": "./app/javascript/images/playbook-cover.png",
	"./playbook-cover.png": "./app/javascript/images/playbook-cover.png",
	"./post-office": "./app/javascript/images/post-office.svg",
	"./post-office.svg": "./app/javascript/images/post-office.svg",
	"./reporting-paradigm-background": "./app/javascript/images/reporting-paradigm-background.png",
	"./reporting-paradigm-background.png": "./app/javascript/images/reporting-paradigm-background.png",
	"./reporting-recommendation-questions": "./app/javascript/images/reporting-recommendation-questions.png",
	"./reporting-recommendation-questions.png": "./app/javascript/images/reporting-recommendation-questions.png",
	"./safeAndSound-logo": "./app/javascript/images/safeAndSound-logo.svg",
	"./safeAndSound-logo.svg": "./app/javascript/images/safeAndSound-logo.svg",
	"./share-icon": "./app/javascript/images/share-icon.svg",
	"./share-icon.svg": "./app/javascript/images/share-icon.svg",
	"./share-twitter": "./app/javascript/images/share-twitter.svg",
	"./share-twitter.svg": "./app/javascript/images/share-twitter.svg",
	"./social-isolation-2020": "./app/javascript/images/social-isolation-2020.png",
	"./social-isolation-2020.png": "./app/javascript/images/social-isolation-2020.png",
	"./substained-abuse-graph": "./app/javascript/images/substained-abuse-graph.png",
	"./substained-abuse-graph-2023": "./app/javascript/images/substained-abuse-graph-2023.svg",
	"./substained-abuse-graph-2023.svg": "./app/javascript/images/substained-abuse-graph-2023.svg",
	"./substained-abuse-graph.png": "./app/javascript/images/substained-abuse-graph.png",
	"./teach": "./app/javascript/images/teach.svg",
	"./teach.svg": "./app/javascript/images/teach.svg",
	"./team": "./app/javascript/images/team.svg",
	"./team.svg": "./app/javascript/images/team.svg",
	"./top-1-share-income": "./app/javascript/images/top-1-share-income.png",
	"./top-1-share-income.png": "./app/javascript/images/top-1-share-income.png",
	"./unemployment-graph-2023": "./app/javascript/images/unemployment-graph-2023.svg",
	"./unemployment-graph-2023.svg": "./app/javascript/images/unemployment-graph-2023.svg",
	"./unemployment_by_county_dec_2020": "./app/javascript/images/unemployment_by_county_dec_2020.png",
	"./unemployment_by_county_dec_2020.png": "./app/javascript/images/unemployment_by_county_dec_2020.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/images sync recursive ^\\.\\/.*$";